"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TokenLabel = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _typography = require("../../../constants/typography");
const TokenLabel = (0, _styled.default)("span")`
    align-items: center;
    font-size: ${_typography.tag.size}px;
    font-weight: 500;
    line-height: 28px;
    padding: 0 6px 0 4px;

    // Elide if the token is wider than its container.
    display: inline;
    min-width: 0;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
`;
exports.TokenLabel = TokenLabel;
//# sourceMappingURL=TokenLabel.js.map